const PRIORITY_DEFS = [
  { value: 'high',   label: 'High',   color: '#ef4444', order: 0 },
  { value: 'medium', label: 'Medium', color: '#f59e0b', order: 1 },
  { value: 'low',    label: 'Low',    color: '#22c55e', order: 2 },
];

export const PRIORITY_COLORS  = Object.fromEntries(PRIORITY_DEFS.map((p) => [p.value, p.color]));
export const PRIORITY_CONFIG  = Object.fromEntries(PRIORITY_DEFS.map((p) => [p.value, { color: p.color, label: p.label, order: p.order }]));
export const PRIORITY_OPTIONS = PRIORITY_DEFS.map((p) => ({ value: p.value, label: p.label, dot: p.color }));
